(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates(), "/");
    }

    function getStates() {
        return [
            {
                state: 'dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/dashboard/dashboard.html',
                    controller: 'Dashboard',
                    controllerAs: 'vm',
                    title: 'Dashboard',
                    settings: {
                        nav: 1,
                        name: 'dashboard',
                        icon: 'fa fa-bar-chart',
                        content: 'Dashboard',
                        breadcrumb: 'Dashboard',
                        breadcrumbIcon: 'dashboard',
                        resource: 'menu.dashboard'
                    }
                }
            }
        ];
    }
})();